<template>
  <div class="pb">
    <div class="pb__top">
      <div class="pb__label">
        <slot name="label">Progress</slot>
      </div>
      <div class="pb__pct mono">{{ safePct.toFixed(1) }}%</div>
    </div>

    <div class="pb__track" role="progressbar" :aria-valuenow="safePct" aria-valuemin="0" aria-valuemax="100">
      <div
        class="pb__fill"
        :class="fillClass"
        :style="{ width: safePct + '%' }"
      />
    </div>

    <div class="pb__meta">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: { pct: { type: Number, default: 0 } },
  computed: {
    safePct () {
      var p = Number(this.pct || 0)
      if (isNaN(p)) p = 0
      if (p < 0) p = 0
      if (p > 100) p = 100
      return p
    },
    fillClass () {
      if (this.safePct >= 80) return 'pb__fill--good'
      if (this.safePct >= 50) return 'pb__fill--warn'
      return 'pb__fill--neutral'
    }
  }
}
</script>

<style scoped>
.pb{ width:100%; }

.pb__top{
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  margin-bottom:8px;
}
.pb__label{
  font-size:12px;
  font-weight:900;
  color: rgba(0,0,0,.6);
}
.pb__pct{
  font-size:12px;
  font-weight:900;
  opacity:.8;
}

.pb__track{
  height:12px;
  border-radius:999px;
  overflow:hidden;
  background: rgba(0,0,0,.08);
  border:1px solid rgba(0,0,0,.08);
  box-shadow: inset 0 1px 0 rgba(255,255,255,.7);
}
.pb__fill{
  height:100%;
  border-radius:999px;
  transition: width .35s ease;
  box-shadow: 0 6px 16px rgba(0,0,0,.10);
}

/* colors based on % */
.pb__fill--good{
  background: linear-gradient(90deg, #22c55e, #16a34a);
}
.pb__fill--warn{
  background: linear-gradient(90deg, #f59e0b, #d97706);
}
.pb__fill--neutral{
  background: linear-gradient(90deg, #60a5fa, #3b82f6);
}

.pb__meta{
  margin-top:8px;
  font-size:12px;
  font-weight:800;
  color: rgba(0,0,0,.55);
}

.mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
</style>
